/** 公开页面：服务条款、隐私政策（pages/public/legal.tsx） */
const messages = {
  'terms.title': '服务条款',
  'privacy.title': '隐私政策',
  'version': '第 {version} 版',
};

export default messages;
